import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Admin/Dashboard/Dashboard";
import Donors from "../pages/Admin/Donation/Donation";
import Volunteers from "../pages/Admin/Volunteer/Volunteer";
import Login from "../pages/Admin/Auth/Login.tsx";

import AdminLayout from "../components/Admin/Layout/AdminLayout";
import ContactSubmissions from "../pages/Admin/ContactSubmission/ContactSubmission";
import Events from "../pages/Admin/Event/Event";
import Resources from "../pages/Admin/Resources/Resources";
import Media from "../pages/Admin/Media/Media";
import EmailLayout from "../components/Admin/Email/EmailLayout";
import DonateSuccess from "../pages/Donate/DonateSuccess";
import ContactSuccess from "../pages/ContactUs/ContactSuccess";



interface RouterProps {
  isAuthenticated: boolean;
}

const Router: React.FC<RouterProps> = ({ isAuthenticated }) => (
  <Routes>
    {/* Wrap Admin Routes with AdminLayout */}
    {isAuthenticated ? (
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/donors" element={<Donors />} />
        <Route path="/volunteers" element={<Volunteers />} />
        <Route path="/contact-submissions" element={<ContactSubmissions />} />
        <Route path="/admin/events" element={<Events />} />
        <Route path="/admin/resources" element={<Resources />} />
        <Route path="/admin/media" element={<Media />} />
        <Route path="/admin/email" element={<EmailLayout />} />
        <Route path="/donate/success" element={<DonateSuccess />} />
        <Route path="/contact/success" element={<ContactSuccess />} />
        <Route path="*" element={<Navigate to="/" />} />
       

      </Route>
    ) : (
      <Route path="*" element={<Login/>} />
    )}
  </Routes>
);

export default Router;
